import React, { useEffect, useRef, useState } from 'react';
import * as flameco from '../../flameco/flameco-auth';
import { useFlamecoAuth } from '../../flameco/FlamecoAuthProvider';
import { StateScreen } from '../../flameco-ui';

// Back from the Flameco login page (auth.flameco.com). Mounted outside every
// guard and outside the frame. Same flow as the skill's <FlamecoCallback>, shown
// with the kit's whole-screen states.
const AuthCallback: React.FC<{ onDone: (returnTo: string) => void }> = ({ onDone }) => {
  const [error, setError] = useState('');
  const ran = useRef(false); // React StrictMode runs effects twice; a code works once
  const { ready } = useFlamecoAuth();

  useEffect(() => {
    if (!ready || ran.current) return;
    ran.current = true;
    flameco
      .handleCallback()
      .then(({ returnTo }) => onDone(returnTo))
      // A silent check found nobody: on to the login page, landing where the
      // person was going (never back on this callback, which would loop).
      .catch(e => (e instanceof flameco.LoginRequiredError ? flameco.signIn({ returnTo: e.returnTo }) : setError(e.message)))
      .catch(e => setError(e?.message || 'Sign-in could not start.'));
  }, [ready, onDone]);

  if (!error) return <StateScreen title="Signing you in…" busy />;
  return (
    <StateScreen
      title="Sign-in did not finish"
      text={error}
      actions={
        <button type="button" className="fl-btn fl-btn--primary" onClick={() => void flameco.signIn({ returnTo: '/' })}>
          Try again
        </button>
      }
    />
  );
};

export default AuthCallback;
